import React from "react";
import iconWord from "../../img/icons-ext-file/iconWord.png"

export default function FileWord() {
    return (
        <img src={iconWord} alt="" />
    );
}